import React from 'react';
import HolderAdded from '../../../components/Profile/HolderAdded';

const CardLawyers = ({ holders }) => {
    return (
        <>
            <section className="containerMain">
                <p className="containerMain_title">Titular del despacho</p>
                <article className="cardMain">
                    <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                        {holders && holders ? (holders.map((item, index) => (
                            <HolderAdded preview={true} key={index} elements={item} nElem={index} allHolders={holders} />
                        ))) : null}

                    </div>
                </article>

            </section>

        </>
    );
}

export default CardLawyers;